<template>
  <div>
    <uploadImagesBtn @getImageUrl="getImageUrl" />
    <el-button type="text" @click="chooseBanners">从素材库选择</el-button>
    <div class="cover_image_listx flex" v-if="list.length > 0">
      <draggable v-model="list" group="image">
        <div class="img" v-for="(item, index) in list" :key="index">
          <i class="el-icon-delete" @click.stop="deleteImg(index)"></i>
          <el-image :src="item" fit="cover"></el-image>
        </div>
      </draggable>
    </div>
    <p class="font-12 color-999">建议尺寸：800*800像素，拖拽图片可以调整顺序，最多上传15张</p>
    <el-dialog
      title="选择图片"
      width="80%"
      destroy-on-close
      :visible.sync="visible"
      :modal="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <imageDialog @closeImageDialog="closeImageDialog" @confirmImageDialog="confirmImageDialog" />
    </el-dialog>
  </div>
</template>

<script>
  import draggable from "vuedraggable";
  import uploadImagesBtn from "./uploadImagesBtn.vue";
  import MaterialLibrary from "./materialLibraryDialog/index";
  import imageDialog from "./imageDialog.vue";

  export default {
    components: {
      draggable,
      MaterialLibrary,
      imageDialog,
      uploadImagesBtn,
    },
    props: {
      images: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        visible: false,
        list: [],
      };
    },
    watch: {
      images: {
        handler(data) {
          this.list = [...data];
        },
        immediate: true,
      },
    },
    methods: {
      onChange() {
        this.$emit("update:images", this.list);
      },
      chooseBanners() {
        this.visible = true;
      },
      closeImageDialog() {
        this.visible = false;
      },
      getImageUrl(item) {
        this.list.push(item);
        this.onChange();
      },
      confirmImageDialog(item) {
        item.map((i) => {
          this.list.push(i.url);
        });
        this.visible = false;
        this.onChange();
      },
      // 删除图片
      deleteImg(index) {
        this.list.splice(index, 1);
        this.onChange();
      },
    },
  };
</script>
<style scoped>
  .cover_image_listx > div {
    flex-wrap: wrap;
    margin-top: 20px;
    display: flex;
  }
  .cover_image_listx .img {
    position: relative;
    border: 1px solid #dcdcdc;
    width: 180px;
    height: 180px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .cover_image_listx .img .el-icon-delete {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #fff;
    z-index: 2;
    cursor: pointer;
  }
  .cover_image_listx .img .el-image {
    width: 100%;
    height: 100%;
  }
</style>
